import RefreshIcon from "../Icons/RefreshIcon";
import AddIcon from "../Icons/AddIcon";
import FilterIcon from "../Icons/FilterIcon";
import SearchIcon from "../Icons/SearchIcon";
import CalenderIcon from "../Icons/CalenderIcon";
import TickMarkIcon from "../Icons/TickMarkIcon";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useState } from "react";
import SearchToggle from "./SearchToggle";

export default function MenueBar({
  clickOnManueBarButton,
  isClosing,
  showModal,
  calendarOpen,
  showCalender,
  clickOnCalenderManue,
  setOpenSearchToggle,
  openSearchToggle,
  setShowSearchToggle,
  openFilterToggle,
  setOpenFilterToggle,
  setShowFilterToggle,
  openSelectorToggle,
  setOpenSelectorToggle,
  setShowSelectorToggle,
}) {
  const [currentCalendar, setCurrentCalendar] = useState("Gregorian");

  function clickOnSearchToggle(e) {
    setShowSearchToggle(true);

    clickOnManueBarButton(e);
    if (!openSearchToggle) {
      setTimeout(() => {
        setOpenSearchToggle(true);
      }, 300);
    } else {
      setOpenSearchToggle(true);
    }
  }

  function clickOnFilterToggle(e) {
    setShowFilterToggle((prev) => !prev);

    clickOnManueBarButton(e);
    if (!openFilterToggle) {
      setTimeout(() => {
        setOpenFilterToggle((prev) => !prev);
      }, 300);
    } else {
      setOpenFilterToggle((prev) => !prev);
    }
  }

  function clickOnSelectorToggle(e) {
    setShowSelectorToggle((prev) => !prev);

    clickOnManueBarButton(e);
    if (!openFilterToggle) {
      setTimeout(() => {
        setOpenSelectorToggle((prev) => !prev);
      }, 500);
    } else {
      setOpenSelectorToggle((prev) => !prev);
    }
  }

  function onRefreshBtnClick(e) {
    clickOnManueBarButton(e);
    const time = setTimeout(() => {
      window.location.reload();
    }, 300);
  }

  if (!isClosing) {
    return null;
  }
  return (
    <>
      <div
        onClick={(e) => e.stopPropagation()}
        className={`absolute right-0 top-[50px] z-50 bg-white rounded-xl shadow-lg min-w-[200px]  ${!showModal ? "animate-closeSideBar" : "animate-openSideBar"} `}
      >
        <div className="p-2">
          <button
            onClick={onRefreshBtnClick}
            className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-filter text-green-600 w-4">
              <RefreshIcon></RefreshIcon>
            </i>
            <span className="text-sm text-text-primary">Refresh</span>
          </button>

          <button
            onClick={(e) => clickOnSelectorToggle(e)}
            className="flex w-full items-center space-x-2 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-filter text-blue-600 w-3">
              <AddIcon></AddIcon>
            </i>
            <span className="text-sm">Add Symbol</span>
          </button>

          <button
            onClick={(e) => clickOnFilterToggle(e)}
            className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-filter text-orange-500 w-3">
              <FilterIcon></FilterIcon>
            </i>
            <span className="text-sm">Filter</span>
          </button>

          <button
            onClick={(e) => clickOnSearchToggle(e)}
            className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-search text-purple-500 w-3">
              <SearchIcon></SearchIcon>
            </i>
            <span className="text-sm">Search</span>
          </button>

          <div className="relative">
            <button
              onClick={clickOnCalenderManue}
              className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
            >
              <i className="fa-solid fa-calendar text-blue-500 w-3">
                <CalenderIcon></CalenderIcon>
              </i>
              <div className="flex flex-row justify-start items-center gap-1">
                <span className="text-sm">Calendar</span>

                <HiOutlineChevronRight
                  className={`size-4 text-[#808080] transition duration-300 transform delay-100 ${showCalender ? "rotate-90" : "rotate-0"}`}
                ></HiOutlineChevronRight>
              </div>

              <i
                className="fa-solid fa-chevron-right text-text-secondary ml-auto text-xs"
                style={{
                  transform: calendarOpen ? "rotate(90deg)" : "rotate(0deg)",
                }}
              />
            </button>

            {calendarOpen && (
              <div
                className={`absolute right-full  top-0 z-60 bg-white rounded-xl border border-border shadow-lg min-w-[150px] mr-2 ${showCalender ? "animate-slideInFromLeft" : "animate-slideOutToLeft"}`}
              >
                {["Persian", "Gregorian"]?.map((cal) => (
                  <button
                    key={cal}
                    onClick={() => {
                      setCurrentCalendar(cal);
                      clickOnCalenderManue();
                    }}
                    className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
                  >
                    <span className="text-sm">{cal}</span>
                    {currentCalendar === cal && (
                      <i className="text-blue-700 w-3 fa-solid fa-search">
                        <TickMarkIcon></TickMarkIcon>
                      </i>
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
